"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Avatar_1 = __importDefault(require("../Avatar"));
var Badge_1 = __importDefault(require("../Badge"));
var Colors_1 = require("../Colors");
var config_1 = require("../config");
var employeeCard = function (props) {
    var badge = props.badge, badgeColor = props.badgeColor, children = props.children, imageUrl = props.imageUrl, degreeBefore1 = props.degreeBefore1, degreeBefore2 = props.degreeBefore2, degreeAfter = props.degreeAfter, name = props.name, shortInfo = props.shortInfo, withImage = props.withImage;
    var b = config_1.block("employeecard");
    var degreeBefore = degreeBefore1;
    if (degreeBefore2) {
        degreeBefore += " " + degreeBefore2;
    }
    return (react_1.default.createElement("div", { className: b({}, { hasChildren: !!children }) },
        withImage && react_1.default.createElement(Avatar_1.default, { className: b("avatar"), size: children ? 110 : 70, uri: imageUrl }),
        react_1.default.createElement("div", { className: b("container") },
            react_1.default.createElement("div", { className: b("header") },
                react_1.default.createElement("h1", { className: b("title") },
                    degreeBefore && react_1.default.createElement("span", { className: b("degree") }, degreeBefore),
                    react_1.default.createElement("span", { className: b("name") }, name),
                    degreeAfter && react_1.default.createElement("span", { className: b("degree") }, degreeAfter)),
                badge && react_1.default.createElement(Badge_1.default, { color: badgeColor || Colors_1.BaseColor.Gray }, badge)),
            react_1.default.createElement("span", { className: b("subtitle") }, shortInfo),
            !!children && react_1.default.createElement("div", null, children))));
};
exports.default = employeeCard;
//# sourceMappingURL=index.js.map